import Layout from './Layout'
import GamesList from './GamesList';
import Breadcrumbs from './Breadcrumbs';

const Games = () => {
  return (
      <Layout>
          <Breadcrumbs />
          <GamesList/>
      </Layout>
    );
};

export default Games;